const gettime = {
	//上月的第一天和最后一天
	gettimeStar_end_Fun(){
		let nowdays = new Date();
		let year = nowdays.getFullYear();
		let month = nowdays.getMonth();
		if(month==0){
			month=12;
			year=year-1;
		}
		if (month < 10) {
			month = "0" + month;
		}
		 let firstDayOfPreMonth = year + "-" + month + "-" + "01"+ " " + "00:00:00";
		 let lastDay = new Date(year, month, 0);
		 let lastDayOfPreMonth = year + "-" + month + "-" + lastDay.getDate()+ " " + "23:59:59";
		 let obj = {
			first:firstDayOfPreMonth,
			last:lastDayOfPreMonth,
		}
		return obj
	},
	//js获取从本月1号 的时间戳
	getnowMonthStarDateFun(){
		let start = new Date()
		return  start.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), 1)) 
	},
	//console.log(format(getnowMonthStarDateFun(), 3))
	
	//当前时间  2020-09-03 22:51:52
	// getnowDateFun(){
	// 	var timestamp = Date.parse(new Date())
	// 	console.log(format(timestamp, 3))
	// },
    // 计算当前日期星座
    getHoroscope(date) {
        let c = ['摩羯', '水瓶', '双鱼', '白羊', '金牛', '双子', '巨蟹', '狮子', '处女', '天秤', '天蝎', '射手', '摩羯']
        date = new Date(date);
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let startMonth = month - (day - 14 < '865778999988'.charAt(month));
        return c[startMonth] + '座';
    },
    // 计算指定时间与当前的时间差
    sumAge(data) {
        let dateBegin = new Date(data.replace(/-/g, "/"));
        let dateEnd = new Date(); //获取当前时间
        let dateDiff = dateEnd.getTime() - dateBegin.getTime(); //时间差的毫秒数
        let dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
        let leave1 = dateDiff % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
        let hours = Math.floor(leave1 / (3600 * 1000)) //计算出小时数
        //计算相差分钟数
        let leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
        let minutes = Math.floor(leave2 / (60 * 1000)) //计算相差分钟数
        //计算相差秒数
        let leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
        let seconds = Math.round(leave3 / 1000)
        return dayDiff + "天 " + hours + "小时 ";
    },
    // 获取聊天时间（相差300s内的信息不会显示时间）
    getChatTime(v1, v2) {
        v1 = v1.toString().length < 13 ? v1 * 1000 : v1;
        v2 = v2.toString().length < 13 ? v2 * 1000 : v2;
        if (((parseInt(v1) - parseInt(v2)) / 1000) > 300) {
            return this.gettime(v1);
        }
    },
    // 人性化时间格式  
    gettime(shorttime) {
        shorttime = shorttime.toString().length < 13 ? shorttime * 1000 : shorttime;
        let now = (new Date()).getTime();
        let cha = (now - parseInt(shorttime)) / 1000;

        if (cha < 43200) {
            // 当天
            return this.dateFormat(new Date(shorttime), "{A} {t}:{ii}");
        } else if (cha < 518400) {
            // 隔天 显示日期+时间
            // return this.dateFormat(new Date(shorttime), "{Mon}月{DD}日 {A} {t}:{ii}");
            return this.dateFormat(new Date(shorttime), "{Mon}.{DD} {A} {t}:{ii}");
        } else {
            // 隔年 显示完整日期+时间
            return this.dateFormat(new Date(shorttime), "{Y}.{MM}.{DD} {A} {t}:{ii}");
        }
    },

    //数字补零
    parseNumber(num) {
        return num < 10 ? "0" + num : num;
    },

    dateFormat(date, formatStr) {
        let dateObj = {},
            rStr = /\{([^}]+)\}/,
            // mons = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'];
            mons = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

        dateObj["Y"] = date.getFullYear();
        dateObj["M"] = date.getMonth() + 1;
        dateObj["MM"] = this.parseNumber(dateObj["M"]);
        dateObj["Mon"] = mons[dateObj['M'] - 1];
        dateObj["D"] = date.getDate();
        dateObj["DD"] = this.parseNumber(dateObj["D"]);
        dateObj["h"] = date.getHours();
        dateObj["hh"] = this.parseNumber(dateObj["h"]);
        dateObj["t"] = dateObj["h"] > 12 ? dateObj["h"] - 12 : dateObj["h"];
        dateObj["tt"] = this.parseNumber(dateObj["t"]);
        dateObj["A"] = dateObj["h"] > 12 ? '下午' : '上午';
        dateObj["i"] = date.getMinutes();
        dateObj["ii"] = this.parseNumber(dateObj["i"]);
        dateObj["s"] = date.getSeconds();
        dateObj["ss"] = this.parseNumber(dateObj["s"]);

        while (rStr.test(formatStr)) {
            formatStr = formatStr.replace(rStr, dateObj[RegExp.$1]);
        }
        return formatStr;
    },
    // 日期转几分钟前、几小时前显示  datetime 格式为2019-11-22 12:23:59样式
    timeago(dateTimeStamp) { //dateTimeStamp是一个时间毫秒，注意时间戳是秒的形式，在这个毫秒的基础上除以1000，就是十位数的时间戳。13位数的都是时间毫秒。
        // var dateTimeStamp = new Date(datetime.replace(/ /, 'T')).getTime() - 8 * 60 * 60 * 1000; //这里要减去中国的时区8小时
        dateTimeStamp = dateTimeStamp.toString().length < 13 ? dateTimeStamp * 1000 : dateTimeStamp;
        var minute = 1000 * 60; //把分，时，天，周，半个月，一个月用毫秒表示
        var hour = minute * 60;
        var day = hour * 24;
        var week = day * 7;
        var halfamonth = day * 15;
        var month = day * 30;
        var now = new Date().getTime(); //获取当前时间毫秒
        var diffValue = now - dateTimeStamp; //时间差

        if (diffValue < 0) {
            // console.log("diffValue<0", datetime, dateTimeStamp, now, diffValue);
            return '刚刚';
        }
        var minC = diffValue / minute; //计算时间差的分，时，天，周，月
        var hourC = diffValue / hour;
        var dayC = diffValue / day;
        var weekC = diffValue / week;
        var monthC = diffValue / month;
        var result = "2";
        if (monthC >= 1 && monthC <= 3) {
            result = " " + parseInt(monthC) + "月前"
        } else if (weekC >= 1 && weekC <= 3) {
            result = " " + parseInt(weekC) + "周前"
        } else if (dayC >= 1 && dayC <= 6) {
            result = " " + parseInt(dayC) + "天前"
        } else if (hourC >= 1 && hourC <= 23) {
            result = " " + parseInt(hourC) + "小时前"
        } else if (minC >= 1 && minC <= 59) {
            result = " " + parseInt(minC) + "分钟前"
        } else if (diffValue >= 0 && diffValue <= minute) {
            result = "刚刚"
        } else {
            var datetime = new Date();
            datetime.setTime(dateTimeStamp);
            var Nyear = datetime.getFullYear(); {}
            var Nmonth = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
            var Ndate = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
            var Nhour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
            var Nminute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
            var Nsecond = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
            result = Nyear + "-" + Nmonth + "-" + Ndate
        }
        return result;

    },

    //根据时间戳  转换时间格式  ：  2014-02-02
    //运用this.gettime.format(Date.parse(new Date()),0) 
    format(time2, type) {
        if (!time2) {
            return;
        }
        let time = new Date(time2)
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        var s = time.getSeconds();
        if (type == 0) {
            console.log(d)
            return this.parseNumber(d);
        } else if (type == 1) {
            return y + '-' + this.parseNumber(m) + '-' + this.parseNumber(d);
        } else if (type == 2) {
            return this.parseNumber(m) + '月' + this.parseNumber(d) + '日' + '\xa0\xa0\xa0' + this.parseNumber(h) + ':' + this.parseNumber(mm);
        } else if (type == 3) {
            return y + '-' + this.parseNumber(m) + '-' + this.parseNumber(d) + ' ' + this.parseNumber(h) + ':' + this.parseNumber(mm) + ':' + this.parseNumber(s);
        } else if (type == 4) {
            return y;
        }else if (type == 5) {
			// 时间格式：8/6 18:51:11
            return m + '/' + d + ' ' + this.parseNumber(h) + ':' + this.parseNumber(mm) + ':' + this.parseNumber(s);
        } else {
            return y + '-' + this.parseNumber(m) + '-' + this.parseNumber(d) + ' ' + this.parseNumber(h) + ':' + this.parseNumber(mm) + ':' + this.parseNumber(s);
        }
    },
    /* 获取当前时间戳
     */
    nowTime() {
        let now = new Date().getTime() / 1000
        return Math.floor(now)
    },

    /** 
     * 将秒数换成时分秒格式  
     */
    formatSeconds(value) {
        var secondTime = parseInt(value); // 秒
        var minuteTime = 0; // 分
        var hourTime = 0; // 小时
        if (secondTime > 60) { //如果秒数大于60，将秒数转换成整数
            //获取分钟，除以60取整数，得到整数分钟
            minuteTime = parseInt(secondTime / 60);
            //获取秒数，秒数取佘，得到整数秒数
            secondTime = parseInt(secondTime % 60);
            //如果分钟大于60，将分钟转换成小时
            if (minuteTime > 60) {
                //获取小时，获取分钟除以60，得到整数小时
                hourTime = parseInt(minuteTime / 60);
                //获取小时后取佘的分，获取分钟除以60取佘的分
                minuteTime = parseInt(minuteTime % 60);
            }
        }
        var result = "" + parseInt(secondTime) + "秒";

        if (minuteTime > 0) {
            result = "" + parseInt(minuteTime) + "分" + result;
        }
        if (hourTime > 0) {
            result = "" + parseInt(hourTime) + "小时" + result;
        }
        return result;
    },
    //返回农历  如：农历   庚子鼠年    八月十六
    getNonLiFun(){
        function showCal() {
            var D = new Date();
            var yy = D.getFullYear();
            var mm = D.getMonth() + 1;
            var dd = D.getDate();
            var ww = D.getDay();
            var ss = parseInt(D.getTime() / 1000);
            if (yy < 100) yy = '19' + yy;
            return GetLunarDay(yy, mm, dd);
        }

        //定义全局变量
        var CalendarData = new Array(100);
        var madd = new Array(12);
        var tgString = '甲乙丙丁戊己庚辛壬癸';
        var dzString = '子丑寅卯辰巳午未申酉戌亥';
        var numString = '一二三四五六七八九十';
        var monString = '正二三四五六七八九十冬腊';
        var weekString = '日一二三四五六';
        var sx = '鼠牛虎兔龙蛇马羊猴鸡狗猪';
        var cYear, cMonth, cDay, TheDate;
        CalendarData = new Array(
            0xa4b,
            0x5164b,
            0x6a5,
            0x6d4,
            0x415b5,
            0x2b6,
            0x957,
            0x2092f,
            0x497,
            0x60c96,
            0xd4a,
            0xea5,
            0x50da9,
            0x5ad,
            0x2b6,
            0x3126e,
            0x92e,
            0x7192d,
            0xc95,
            0xd4a,
            0x61b4a,
            0xb55,
            0x56a,
            0x4155b,
            0x25d,
            0x92d,
            0x2192b,
            0xa95,
            0x71695,
            0x6ca,
            0xb55,
            0x50ab5,
            0x4da,
            0xa5b,
            0x30a57,
            0x52b,
            0x8152a,
            0xe95,
            0x6aa,
            0x615aa,
            0xab5,
            0x4b6,
            0x414ae,
            0xa57,
            0x526,
            0x31d26,
            0xd95,
            0x70b55,
            0x56a,
            0x96d,
            0x5095d,
            0x4ad,
            0xa4d,
            0x41a4d,
            0xd25,
            0x81aa5,
            0xb54,
            0xb6a,
            0x612da,
            0x95b,
            0x49b,
            0x41497,
            0xa4b,
            0xa164b,
            0x6a5,
            0x6d4,
            0x615b4,
            0xab6,
            0x957,
            0x5092f,
            0x497,
            0x64b,
            0x30d4a,
            0xea5,
            0x80d65,
            0x5ac,
            0xab6,
            0x5126d,
            0x92e,
            0xc96,
            0x41a95,
            0xd4a,
            0xda5,
            0x20b55,
            0x56a,
            0x7155b,
            0x25d,
            0x92d,
            0x5192b,
            0xa95,
            0xb4a,
            0x416aa,
            0xad5,
            0x90ab5,
            0x4ba,
            0xa5b,
            0x60a57,
            0x52b,
            0xa93,
            0x40e95
        );
        madd[0] = 0;
        madd[1] = 31;
        madd[2] = 59;
        madd[3] = 90;
        madd[4] = 120;
        madd[5] = 151;
        madd[6] = 181;
        madd[7] = 212;
        madd[8] = 243;
        madd[9] = 273;
        madd[10] = 304;
        madd[11] = 334;

        function GetBit(m, n) {
            return (m >> n) & 1;
        }
        //农历转换
        function e2c() {
            TheDate = arguments.length != 3 ? new Date() : new Date(arguments[0], arguments[1], arguments[2]);
            var total, m, n, k;
            var isEnd = false;
            var tmp = TheDate.getYear();
            if (tmp < 1900) {
                tmp += 1900;
            }
            total = (tmp - 1921) * 365 + Math.floor((tmp - 1921) / 4) + madd[TheDate.getMonth()] + TheDate.getDate() - 38;

            if (TheDate.getYear() % 4 == 0 && TheDate.getMonth() > 1) {
                total++;
            }
            for (m = 0;; m++) {
                k = CalendarData[m] < 0xfff ? 11 : 12;
                for (n = k; n >= 0; n--) {
                    if (total <= 29 + GetBit(CalendarData[m], n)) {
                        isEnd = true;
                        break;
                    }
                    total = total - 29 - GetBit(CalendarData[m], n);
                }
                if (isEnd) break;
            }
            cYear = 1921 + m;
            cMonth = k - n + 1;
            cDay = total;
            if (k == 12) {
                if (cMonth == Math.floor(CalendarData[m] / 0x10000) + 1) {
                    cMonth = 1 - cMonth;
                }
                if (cMonth > Math.floor(CalendarData[m] / 0x10000) + 1) {
                    cMonth--;
                }
            }
        }

        function GetcDateString() {
            var tmp = '';
            /*显示农历年：（ 如：甲午(马)年 ）*/
            tmp += tgString.charAt((cYear - 4) % 10);
            tmp += dzString.charAt((cYear - 4) % 12);
            tmp += sx.charAt((cYear - 4) % 12);
            tmp += "年 ";
            tmp += '\xa0\xa0\xa0';
            if (cMonth < 1) {
                tmp += '(闰)';
                tmp += monString.charAt(-cMonth - 1);
            } else {
                tmp += monString.charAt(cMonth - 1);
            }
            tmp += '月';
            tmp += cDay < 11 ? '初' : cDay < 20 ? '十' : cDay < 30 ? '廿' : '三十';
            if (cDay % 10 != 0 || cDay == 10) {
                tmp += numString.charAt((cDay - 1) % 10);
            }
            return tmp;
        }

        function GetLunarDay(solarYear, solarMonth, solarDay) {
            //solarYear = solarYear<1900?(1900+solarYear):solarYear;
            if (solarYear < 1921 || solarYear > 2020) {
                return '';
            } else {
                solarMonth = parseInt(solarMonth) > 0 ? solarMonth - 1 : 11;
                e2c(solarYear, solarMonth, solarDay);
                return '农历' + '\xa0\xa0\xa0' + GetcDateString();
            }
        }
        return  showCal() + ' ';
    }
}

export default gettime